var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"book"}},[_vm._v("book")])
}
var staticRenderFns = []

export { render, staticRenderFns }